





























// import Vue from 'vue';
import { VNode, CreateElement } from 'vue';
import { Component } from 'vue-property-decorator';
import { SwExtendedVue } from '@libs-uuif/shared/sw-extended-vue';
import UUIFComponents from '@/shared/uuifComponent';
import { TabProps } from '@sonicwall/unified-ui-framework/src/shared/sw-tab-layout';
import AccessMgmtUserList from './components/msw-accessmgmt-userlist.vue';
import { SwIcon } from '@libs-uuif/shared/sw-icon';
import { TooltipDirValues } from '@libs-uuif/shared/tooltip-dir';
import AccessMgmtUserGroup from './components/msw-accessmgmt-userGroup.vue';
import { SetHelpContentIdPayload } from '@/core/core.store';
import { Mutation } from 'vuex-class';
import { currentUserKey } from '@/shared/msw-constants';
import MswAffiliationsTab from '@/modules/msw-products/components/msw-user-group/affiliations-tab.vue';
import * as decode from 'jwt-decode';
import { VuexMappedMutation } from '@libs-uuif/shared/common-types';

const cssPrefix = 'access-mgmt';
@Component({
  components: {
    ...UUIFComponents,
    AccessMgmtUserList,
    SwIcon,
    AccessMgmtUserGroup,
    MswAffiliationsTab,
  },
})
export default class MswAccessMgmt  extends SwExtendedVue {
  cssPrefix = cssPrefix;

  @Mutation
  setHelpContentId: VuexMappedMutation<SetHelpContentIdPayload>;

  selectedTabId: 'user-list' | 'user-groups' = 'user-groups';
  accessMgmtTabs: TabProps[] = [
    { tabId: 'user-list', label: String(this.$t('accessMgmt.users')) },
  ];

  /* tslint:disable-next-line */
  get isMasterMssp() {
    const roles = JSON.parse(this.$store.getters.getUserInfo).user.roles || [];
    return roles.indexOf('MASTERMSSP') > -1 ? true : false;
  }

  /* tslint:disable-next-line */
  userGroupTabHeaderRender(h: CreateElement, data: any): VNode[] {
    const nodes: VNode[] = [
      <span>{ this.$t('accessMgmt.usrGrps') } &nbsp;</span> as VNode,
      <SwIcon
        name={'info'}
        v-tooltip={{ compact: true, content: String(this.$t('accessMgmt.usrGrpPerMssp')) } as TooltipDirValues}
      /> as VNode,
    ];
    return nodes;
  }
  onChangeTab(tabId: 'user-list' | 'user-groups') {
    this.selectedTabId = tabId;
  }

  routeToUsergGroup(userGroup: string) {
    this.selectedTabId = 'user-groups';
    this.$store.commit('AccessManagementStoreModule/setUserGroupNameFromUserListPage', { setSelectedUserGroupName: userGroup });
  }

  setHelpId(value:string) {
    const temp:string[] = [];
    temp.push(value);
    this.setHelpContentId({ helpId:temp });
    window.parent.postMessage({ route: 'mssp-access-management', helpId: temp }, '*');
  }

  mounted() {
    this.setHelpId(this.isMasterMssp ? 'master-mssp-access-mgmt' : 'regular-mssp-access-mgmt');
    const currentUser: any = localStorage.getItem(currentUserKey);
    const token: any = decode(JSON.parse(currentUser)?.token || '');
    if (token.hasOwnProperty('orgbased') && token?.orgbased === 'YES') {
      this.accessMgmtTabs.push(
        {
          tabId: 'tab2',
          label: this.$t('profile.affiliations')
          .toString(),
        },
      );
    }
    this.accessMgmtTabs.push(
      {
        tabId: 'user-groups',
        label: this.userGroupTabHeaderRender,
      },
    );
  }

  updated() {
    this.setHelpId(this.isMasterMssp ? 'master-mssp-access-mgmt' : 'regular-mssp-access-mgmt');
  }

  destroyed() {
    this.setHelpId('default');
  }
}
